

//import { IfcSampleInterface } from './IfcSampleInterface.ts';
//import Maths from './utils/Maths';
//declare var Maths:any;
//declare var Maths:Maths;


window.onload = function (){
    let module:any;
    let app = {
        width: window.innerWidth,
        height: window.innerHeight,
        aspect: window.innerWidth / window.innerHeight
    }
    function init (){
        console.log('-- iframe --')
     
        resize();
    }
    
  
    function resize (){
        app.width = window.innerWidth;
        app.height = window.innerHeight;
        app.aspect = app.width / app.height;
    }

    window.onresize = resize;
    init();
}



// WEBPACK FOOTER //
// ./ts-src/app.ts